module.exports = __webpack_public_path__ + "static/media/iPhone14_3.0f86add4.png";